import React from "react";

import img1 from "../../Assets/Images/GalleryImages/img1.webp";
import img2 from "../../Assets/Images/GalleryImages/img2.webp";
import img3 from "../../Assets/Images/GalleryImages/img3.webp";
import img4 from "../../Assets/Images/GalleryImages/img4.webp";
import img5 from "../../Assets/Images/GalleryImages/img5.webp";
import img6 from "../../Assets/Images/GalleryImages/img6.webp";
import img7 from "../../Assets/Images/GalleryImages/img7.webp";
import img8 from "../../Assets/Images/GalleryImages/img8.webp";
import leaf from "../../Assets/Images/leaf.png";
import { Sparkles } from "lucide-react";

const GalleryImage = ({ img, index, wide = false, dataAos, dataDelay }) => (
  <div
    data-aos={dataAos}
    data-aos-delay={dataDelay}
    data-aos-anchor-placement="top-bottom"
    className={`overflow-hidden rounded-2xl group ${
      wide ? "lg:col-span-2" : ""
    } h-44 sm:h-56 md:h-64 lg:h-80`}
  >
    <img
      src={img}
      alt={`gallery-${index}`}
      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
    />
  </div>
);

const Gallery = () => {
  const images = [img1, img2, img3, img4, img5, img6, img7, img8];

  const row1 = images.slice(0, 3);
  const row2 = images.slice(3, 5);
  const row3 = images.slice(5, 8);

  return (
    <section className="bg-[#FFFAF9] py-8 md:py-12 lg:py-16   px-4 sm:px-8 md:px-10 lg:px-12 mx-auto">
      <div className="mx-auto">
        {/* Header */}
        <div
          data-aos="fade-right"
          className="grid lg:grid-cols-2 gap-4 mb-6 md:mb-12 "
        >
          <div>
            <div className="relative w-fit">
              <div className="absolute -inset-1 bg-gradient-to-r from-[#ab310c] to-[#EDB5A4] rounded-full blur opacity-20 group-hover:opacity-30 transition duration-1000 group-hover:duration-200 animate-pulse" />
              <div className="relative uppercase font-robotoflex flex items-center gap-2 sm:gap-3 border-2 border-white/30 bg-white/90 backdrop-blur-sm rounded-full text-[#ab310c] px-4 sm:px-6 py-1.5 text-sm sm:text-base tracking-wide font-semibold shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 group">
                <img
                  src={leaf}
                  alt="leaf"
                  className="w-5 h-5 sm:w-6 sm:h-6 transition-transform group-hover:rotate-12 duration-300"
                />
                <span className="bg-gradient-to-r from-[#ab310c] to-[#8a290a] bg-clip-text text-transparent">
                  Gallery
                </span>
                <Sparkles className="w-4 h-4 sm:w-5 sm:h-5 text-amber-500 ml-1" />
              </div>
            </div>

            {/* Heading with gradient text */}
            <h1 className="mt-2 text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-philosopher font-bold text-gray-900 leading-tight tracking-tight">
              <span className="bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 bg-clip-text text-transparent">
                Beauty in Every&nbsp;
              </span>
              {/* <br /> */}
              <span className="relative">
                <span className="bg-gradient-to-r from-[#ab310c] via-[#d44a20] to-[#EDB5A4] bg-clip-text text-transparent">
                  Detail
                </span>
                <div className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-32 h-1 bg-gradient-to-r from-[#ab310c] to-[#EDB5A4] rounded-full" />
              </span>
            </h1>
          </div>

          <p className="font-robotoflex flex text-sm md:text-base leading-relaxed  text-left  lg:text-right  text-[#707070] tracking-wide">
            Explore our collection of stunning transformations, flawless makeup,
            stylish hairdos, and relaxing salon moments crafted by our expert
            professionals. From everyday elegance to bridal glam, our gallery
            showcases the artistry, care, and passion we bring to every service.
          </p>
        </div>

        {/* Row 1 */}
        <div className="grid grid-cols-1 sm:grid-cols-2  md:grid-cols-3 gap-6 mb-6">
          {row1.map((img, i) => (
            <GalleryImage
              key={i}
              img={img}
              index={i}
              dataAos="fade-up"
              dataDelay={i * 150}
            />
          ))}
        </div>

        {/* Row 2: Wider images (stack on md) */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 lg:grid-cols-4 gap-6 mb-6">
          <GalleryImage
            dataAos="fade-up"
            key={3}
            img={row2[0]}
            index={3}
            wide
            dataDelay={450}
          />{" "}
          {/* wide image */}
          <GalleryImage
            dataAos="fade-up"
            key={4}
            img={row2[1]}
            index={4}
            wide
            dataDelay={600}
          />{" "}
          {/* wide image */}
        </div>

        {/* Row 3 */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {row3.map((img, i) => (
            <GalleryImage
              key={i}
              img={img}
              index={i + 5}
              dataAos="fade-up"
              dataDelay={(i + 5) * 150}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
